import { Divider } from '@repo/editor/src/components/utilities/styles';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)`
  background: ${themeStyle.varBackgroundAlt};
  border-radius: ${themeStyle.radiusLarge};
  box-shadow: ${themeStyle.shadowSoft};
  padding: 0;
  height: 100%;
`;

export const VerticalDivider = styled.div`
  height: 20px;
  width: 1px;
  background: ${themeStyle.varInkSuperLight};

  html[data-theme='dark'] &&,
  .dark && {
    color: ${themeStyle.varInkLight};
  }
`;

export const HeaderWrapper = styled(FlexRow)`
  align-items: center;

  padding: 8px 16px;

  ${QUERIES.largeTabletAndUp} {
    padding: 12px 24px;
  }
`;

export const CardDivider = styled(Divider)`
  color: ${themeStyle.varInkSuperLight};

  html[data-theme='dark'] &&,
  .dark && {
    color: ${themeStyle.varInkLight};
  }
`;

export const FooterWrapper = styled.div<{ small: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;

  padding: 16px 20px 20px;

  ${QUERIES.largeTabletAndUp} {
    padding: 20px;
  }

  flex-direction: ${({ small }) => (small ? 'column' : 'row')};
`;
